import Parameter, { BoolClause } from './Parameter';
import ParameterKeyValue from './ParameterKeyValue';

export default class DeviceFilter extends Parameter {
  private _deviceId: string;

  constructor(deviceId: string) {
    super();
    this._deviceId = deviceId;
  }

  get parameterKeyValue(): ParameterKeyValue {
    return new ParameterKeyValue('device', this._deviceId);
  }

  async getFSSClause(): Promise<BoolClause | null> {
    if (!this._deviceId) {
      return null;
    }

    return {
      bool: {
        must: [
          {
            term: {
              'device.reference.keyword': `Device/${this._deviceId}`,
            },
          },
        ],
      },
    };
  }
}
